import {
  type CreateKudosInput,
  type KudosRow,
  kudosRowSchema,
  type ListKudosQuery,
  type ListKudosResponse,
  listKudosResponseSchema,
} from "@/features/kudos/schemas/kudos.schema";
import { apiCall } from "@/shared/lib/api-call";
import { apiPaths } from "@/shared/lib/api-paths";

/// HTTP boundary for the Kudos feature. Per webui T3 / FE-SEC6 every response
/// is Zod-parsed via the shared `apiCall` helper. All endpoints live under
/// `/workspaces/:workspaceId/kudos`.

function toListQs(query: ListKudosQuery): string {
  const params = new URLSearchParams();
  if (query.cursor) params.set("cursor", query.cursor);
  if (query.limit !== undefined) params.set("limit", String(query.limit));
  if (query.valueTag) params.set("valueTag", query.valueTag);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export async function listKudos(
  workspaceId: string,
  query: ListKudosQuery = {},
): Promise<ListKudosResponse> {
  return apiCall<ListKudosResponse>(
    `${apiPaths.kudos.list(workspaceId)}${toListQs(query)}`,
    { method: "GET" },
    listKudosResponseSchema,
  );
}

export async function createKudos(workspaceId: string, input: CreateKudosInput): Promise<KudosRow> {
  return apiCall<KudosRow>(
    apiPaths.kudos.list(workspaceId),
    { method: "POST", body: JSON.stringify(input) },
    kudosRowSchema,
  );
}

export async function getKudosDetail(workspaceId: string, kudosId: string): Promise<KudosRow> {
  return apiCall<KudosRow>(
    apiPaths.kudos.detail(workspaceId, kudosId),
    { method: "GET" },
    kudosRowSchema,
  );
}
